module.exports = __webpack_public_path__ + "creative-commons-by-nc-sawpe2a1058a53201224f6f84749cc8a3aac.png";